import { useNavigate, useSearchParams } from "react-router-dom";

import { OnboardingSendNotification } from "@/components/onboarding/onboarding-send-notification";
import { OnboardingProgress } from "@/components/onboarding/onboarding-progress";
import { SkipButton } from "@/components/onboarding/skip-button";
import { useUpdateUserSettingsMutation } from "@/hooks/use-user-settings";

export function OnboardingNotificationPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const updateSettings = useUpdateUserSettingsMutation();

  // Debug: ?done in the URL forces the success state.
  const showDoneState = searchParams.has("done");

  const handleSkip = () => {
    navigate("/onboarding/widget");
  };

  const handleSuccess = () => {
    updateSettings.mutate({ onboarding_notification: true });
  };

  return (
    <div className="space-y-8">
      <SkipButton href="/onboarding/widget" fixed />

      <OnboardingProgress
        currentStep={3}
        title="Send a welcome notification to your device"
      />

      <OnboardingSendNotification onSkip={handleSkip} onSuccess={handleSuccess} initialSent={showDoneState} />
    </div>
  );
}
